.activityClock {
    letter-spacing: -1px;
}

.agentStatusButton {
    &[data-variant="subtle"] {
        &:hover {
            background-color: var(--mantine-color-dark-5);
        }
    }
    &[data-opened="true"] {
        background-color: var(--mantine-color-dark-5);
    }
}
